export default __webpack_public_path__ + "static/media/close_add_item.3f4eda06.svg";